import { Controller } from "@hotwired/stimulus"
import { enter, leave } from "el-transition"

// Connects to data-controller="modal"
export default class extends Controller {
	static targets = ["backdrop", "panel", "content"]

	connect() {
		this.show()
	}

	close() {
		Promise.all([leave(this.backdropTarget), leave(this.panelTarget)]).then(() => {
			this.element.remove()
		})
	}

	// hide modal on successful form submission
	// action: "turbo:submit-end->turbo-modal#submitEnd"
	submitEnd(event) {
		if (event.detail.success) this.close()
	}

	// Private Methode

	show() {
		enter(this.backdropTarget)
		enter(this.panelTarget)
	}
}
